import script from "./ExhibitionCrawlManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ExhibitionCrawlManagement.vue?vue&type=script&setup=true&lang=js"

import "./ExhibitionCrawlManagement.vue?vue&type=style&index=0&id=38528ad8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38528ad8"]])

export default __exports__